// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__P9eL8","large":"styles_large__FjWwV"};